import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
          联系我们
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
          {contactInfo.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto">
          {contactInfo.description}
        </p>
        <a
          href={`mailto:${contactInfo.email}`}
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-mail-line text-lg" />
          {contactInfo.email}
        </a>
      </div>
    </section>
  );
}